<template>
  <v-dialog v-model="dialog" width="600" scrollable>
    <v-card v-if="dialog">
      <v-card-title>
        <v-btn
          v-if="contatoAtivo"
          icon
          @click="contatoAtivo = null"
          class="mr-2"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        {{ contatoAtivo ? "Detalhes do contato" : params.titulo }}
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <contato-lista
          v-if="!contatoAtivo"
          v-model="contatos"
          :loading="loading"
          @select="contatoAtivo = $event"
        />
        <contato-detalhes v-else v-model="contatoAtivo" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import ContatoLista from "./ContatoLista";
import ContatoDetalhes from "./ContatoDetalhes";
export default {
  components: { ContatoLista, ContatoDetalhes },
  data() {
    return {
      contatoAtivo: null,
      contatos: [],
      loading: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.contato.paramsLista !== null;
      },
      set(val) {
        if (!val) {
          this.$store.commit("contato/setParamsLista", null);
        }
      },
    },
    ...mapState({
      params: (state) => state.contato.paramsLista,
    }),
  },
  methods: {
    async carregarContatos() {
      this.loading = true;
      try {
        this.contatos = await this.$store.dispatch("contato/listar", {
          tipo_entidade: this.params.tipo_entidade,
          id_entidade: this.params.id_entidade,
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de contatos",
        });
      }
      this.loading = false;
    },
  },
  watch: {
    dialog(val) {
      this.contatoAtivo = null;
      if (val) {
        this.carregarContatos();
      }
    },
  },
};
</script>
